module.exports = __webpack_public_path__ + "img/arithmetic-combinator.b15bb0a6.png";